import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    document.body.style.overflow = !isMobileMenuOpen ? 'hidden' : '';
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    document.body.style.overflow = '';
  };

  const navLinks = [
    { to: '/', label: 'Inicio', exact: true },
    { to: '/servicios', label: 'Servicios' },
    { to: '/trabajos', label: 'Nuestros Trabajos' },
    { to: '/quienes-somos', label: 'Quiénes Somos' },
    { to: '/contacto', label: 'Contacto' },
  ];

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="header__container">
        <Link to="/" className="header__logo" onClick={closeMobileMenu}>
          <img 
            src="/assets/Logo_texto_lado.png" 
            alt="Artelaser3D - Grabado Láser e Impresión 3D en Asturias" 
            className="header__logo-img"
            width="200"
            height="48"
          />
        </Link>

        <nav className="header__nav" aria-label="Navegación principal">
          <ul className="header__nav-list">
            {navLinks.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  end={link.exact}
                  className={({ isActive }) =>
                    `header__nav-link ${isActive ? 'header__nav-link--active' : ''}`
                  }
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="header__actions">
          <Link to="/presupuesto" className="header__cta-btn">
            Presupuesto
          </Link>

          <button
            className="header__mobile-toggle"
            onClick={toggleMobileMenu}
            aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-menu"
          >
            <span className={`header__hamburger ${isMobileMenuOpen ? 'header__hamburger--open' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>

      <div
        id="mobile-menu"
        className={`header__mobile-menu ${isMobileMenuOpen ? 'header__mobile-menu--open' : ''}`}
        aria-hidden={!isMobileMenuOpen}
      >
        <nav className="header__mobile-nav" aria-label="Navegación móvil">
          <ul className="header__mobile-nav-list">
            {navLinks.map((link) => (
              <li key={link.to}>
                <NavLink
                  to={link.to}
                  end={link.exact}
                  className={({ isActive }) =>
                    `header__mobile-nav-link ${isActive ? 'header__mobile-nav-link--active' : ''}`
                  }
                  onClick={closeMobileMenu}
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>

          <Link
            to="/presupuesto"
            className="header__mobile-cta"
            onClick={closeMobileMenu}
          >
            Solicitar Presupuesto
          </Link>

          <div className="header__mobile-contact">
            <p>
              <strong>¿Tienes dudas?</strong>
            </p>
            <a href="mailto:info@artelaser3d.es">info@artelaser3d.es</a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
